/**
 * Tri-state presence indicator styles (Supabase-sourced statuses only).
 *
 * Consumers compose these class/label maps into their own avatar-dot markup
 * (chat invite panel, family member list, header/user menu, love page) so the
 * dot can be positioned per surface while colors/labels stay consistent.
 *
 * @module shared/components/ui/presence-dot
 */

export type PresenceDotStatus = 'online' | 'away' | 'offline';

/** Dot colors per status (readable across all 3 themes). */
export const PRESENCE_DOT_CLASS: Readonly<Record<PresenceDotStatus, string>> = {
  online: 'bg-green-500',
  away: 'bg-amber-500',
  offline: 'bg-zinc-400',
};

/** Bulgarian status labels. */
export const PRESENCE_LABEL: Readonly<Record<PresenceDotStatus, string>> = {
  online: 'Онлайн',
  away: 'Неактивен',
  offline: 'Офлайн',
};
